export enum NodeEnv {
  development = 'development',
  production = 'production',
  test = 'test',
  staging = 'staging',
  e2e = 'e2e',
}

export const isDev = process.env.NODE_ENV === NodeEnv.development;
export const isProd = process.env.NODE_ENV === NodeEnv.production;
export const isTest = process.env.NODE_ENV === NodeEnv.test;
export const isE2E = process.env.NODE_ENV === NodeEnv.e2e;
export const isStaging = process.env.NODE_ENV!.includes(NodeEnv.staging);
export const isPdf = process.env.VUE_APP_BUILD_MODE && process.env.VUE_APP_BUILD_MODE === 'pdf';
